var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-button',{directives:[{name:"gl-tooltip",rawName:"v-gl-tooltip"}],attrs:{"title":_vm.title,"aria-label":_vm.title,"icon":"remove","data-testid":"delete-member-button"},on:{"click":function($event){return _vm.showRemoveMemberModal(_vm.modalData)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }